import type { MonospacePolicyEntitlementResource } from '#layers/access/public';
import { withItemType } from '@rstore/vue';
import { parseEntitlementResources } from '~/rstore/utils/parse-entitlement-resources';

export const WorkspaceEntitlementResource = withItemType<MonospacePolicyEntitlementResource>().defineCollection({
	name: 'WorkspaceEntitlementResource',
	getKey: (item) => item.name,
	meta: {
		endpoint: 'entitlements',
		parse: { many: parseEntitlementResources },
	},
});
